import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'

// Styles
import { Label_s } from 'styles/app-styles'
import { EditProfileForm } from 'components/profile/profile-styles'
// Data
import profileService from 'data/profile'
import { local } from 'data/lib/local-json'
// Inputs
import { InputText_s } from 'styles/input-styles'

const EditProfile: FC = () => {

  const profile               = local('auth.profile');
  const email                = _.get(profile, 'email');
  const orgName              = _.get(profile, 'orgName');
  const [data, setData]      = useState<object>({});
  const [error, updateError] = useState<string>("");

  useEffect(() => {
    profileService.stream().subscribe(obj => {
      if (obj['data']) setData(obj['data']);
      if (obj['error']){
        updateError(obj['error']);
      } else {
        updateError("");
      }
    });
  }, []);

  return (
    <div>
      { error && <Label_s danger>{error}</Label_s> }
      <EditProfileForm>
        <div>
          <Label_s>First Name*</Label_s>
          <InputText_s
            value={data['firstName']}
            onChange={e => profileService.updateData('firstName', e.target.value)}
          />
        </div>
        <div>
          <Label_s>Last Name*</Label_s>
          <InputText_s
            value={data['lastName']}
            onChange={e => profileService.updateData('lastName', e.target.value)}
          />
        </div>
        <div>
          <Label_s>Email Address*</Label_s>
          <InputText_s
            value={email}
            disabled
          />
        </div>
        <div>
          <Label_s>Organization</Label_s>
          <InputText_s
            value={orgName}
            disabled
          />
        </div>
        <div>
          <a href="https://rdcf-static.s3.us-west-2.amazonaws.com/pdf/rDCF+SaaS+Agreement+04.29.2024.pdf" target="_blank">Terms & Conditions</a>
        </div>
      </EditProfileForm>

      {/* <div style={{border: '1px solid #C5D7DC', background: 'rgba(17, 99, 191, .05)', fontSize: '12px', padding: '4px'}}>
        <a href="insert link to privacy policy here" target="_blank" style={{color: '#3E506F'}}><strong>Privacy Policy</strong></a>
      </div> */}

    </div>
  )

}

export default EditProfile